import {Component, input, OnDestroy, OnInit} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  MatAutocompleteModule,
} from "@angular/material/autocomplete";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {distinctUntilChanged, map, Observable, of, startWith, Subject, takeUntil} from "rxjs";
import {IPollToList} from "../../../../../../utils/interfaces/poll";
import {PollTypeEnum} from "../../../../../../utils/enums/poll-type.enum";

@Component({
  selector: 'app-unit-poll-autocomplete',
  standalone: true,
  imports: [
    AsyncPipe,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
  ],
  templateUrl: './unit-poll-autocomplete.component.html',
  styleUrl: './unit-poll-autocomplete.component.scss'
})
export class UnitPollAutocompleteComponent implements OnInit, OnDestroy {
  typePoll = input.required<PollTypeEnum>();
  form = input.required<FormControl<string | null>>();
  formSearch = input.required<FormControl<string | null>>();
  polls = input.required<IPollToList[]>();

  private readonly unsubscribe$ = new Subject<void>();

  filteredPolls!: Observable<IPollToList[]>;

  get label(): string {
    return this.typePoll() === PollTypeEnum.Satisfaction
      ? 'Selecione a pesquisa de satisfação'
      : 'Selecione a pesquisa de reserva de pratos';
  }

  get labelError(): string {
    return this.typePoll() === PollTypeEnum.Satisfaction
      ? 'Pesquisa de satisfação é obrigatório'
      : 'Pesquisa de reserva de pratos é obrigatório';
  }

  ngOnInit(): void {

    this.initFormSearch();
    this.handleFormSearch();

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  checkAddPoll(id: string): void {
    this.form().setValue(id);
  }

  inputBlur() {
    const searchValue = this.formSearch().value?.trim() || '';

    if (!searchValue) {
      this.checkAddPoll('')
      return;
    }

    const poll = this.polls()
      ?.find((poll) => poll.title.toLowerCase().trim() === searchValue.toLowerCase().trim());

    if (this.form().value !== poll?.id) {
      this.checkAddPoll(poll ? poll.id : '');
    }

  }

  private initFormSearch() {
    if (this.form().value) {
      const poll = this.polls()?.find((poll => poll.id === this.form().value));
      if (!poll) {
        return;
      }

      this.formSearch().setValue(poll.title);
    }
  }

  private handleFormSearch() {
    this.filteredPolls = this.formSearch().valueChanges
      .pipe(
        startWith(''),
        distinctUntilChanged(),
        map((value) => {
          if (!value) {
            return this.polls();
          }
          return this.polls().filter((poll) =>
            poll.title.toLowerCase().trim().includes(value.toLowerCase().trim())
          );
        }),
        takeUntil(this.unsubscribe$)
      );
  }

}
